export enum JobStockItemAvailabilityEnum {
  STOCK = "STOCK",
  JO_IN_PROGRESS = "JO_IN_PROGRESS",
  JO_IN_REQUEST = "JO_IN_REQUEST",
  BIN = "BIN",
  UNAVAILABLE = "UNAVAILABLE"
}

export enum ManufactureItemTypeEnum {
  MANUAL = "MANUAL",
  AUTO = "AUTO"
}

export class ItemAvailabilityBaseContainer {
  available_on: JobStockItemAvailabilityEnum;
  server_doc_1: string;
  ad_hoc_qty: number;
}

export class JobStockItemAvailabilityContainerModel {
  item_type_enum: ManufactureItemTypeEnum;
  job_stock_availability: ItemAvailabilityBaseContainer[];
}